import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';
import { EMAIL_REGEX } from 'src/utilities/regexPatterns';

export interface EmailNotificationsControlProps {
  name: string;
  id: string;
}

export function EmailNotificationsControl({
  name,
  id,
}: EmailNotificationsControlProps): JSX.Element {
  const { errors, control } = useFormContext();

  const isEmptyValue = (value: string): boolean | string =>
    String(value).trim() !== '' || 'Please enter your email addresses';

  const label =
    'Enter all SFTP notification email addresses (separated with commas) *';

  const isValidEmails = (value: string): boolean | string => {
    const emails = value.split(',');
    if (emails.length > 10) {
      return 'You can only enter up to 10 email addresses';
    }
    const invalidEmails = emails.filter(
      (email) => !EMAIL_REGEX.test(email.trim())
    );
    return invalidEmails.length === 0 || 'Email addresses are invalid';
  };

  return (
    <CookbookInputWrapper
      name={name}
      id={id}
      control={control}
      error={errors[name]}
      maxLength={800}
      aria-label={name}
      inputSize="medium"
      blockWidth
      placeholder="johnsmith@grubhub.com,markross@grubhub.com"
      label={label}
      rules={{
        required: 'Please enter your email addresses',
        validate: {
          isEmpty: isEmptyValue,
          isValid: isValidEmails,
        },
      }}
    />
  );
}
